import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

const ProductOptions = ({ isOpen, onClose, handleDeleteItem }) => {
  const options = [{ id: 1, text: "Delete", color: "red" }];

  const handleClick = (optionId) => {
    if (optionId === 1) handleDeleteItem();
    onClose();
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="product-options-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            className="product-options-modal"
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 100, opacity: 0 }}
            transition={{ type: "spring", stiffness: 300, damping: 25 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="product-options-header">
              <h3>Options</h3>
              <button className="close-btn" onClick={onClose}>
                <X size={20} />
              </button>
            </div>

            <ul className="product-options-list">
              {options.map((option) => (
                <li
                  key={option.id}
                  onClick={() => handleClick(option.id)}
                  className={`product-option-item ${
                    option.color === "red" ? "danger" : ""
                  }`}
                >
                  {option.text}
                </li>
              ))}
            </ul>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ProductOptions;
